import React from 'react'

import styles from './Dropdown.module.scss'

interface DropdownProps {
  options: string[]
  onChange: React.ChangeEventHandler<HTMLSelectElement>
  value: string
  'data-testid': string
}

const Dropdown: React.FC<DropdownProps> = ({ options, onChange, value, 'data-testid': dataTestId }) => {
  return (
    <div className={styles.container}>
      <select onChange={onChange} value={value} data-testid={dataTestId}>
        <option />
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Dropdown
